const accentColor = '#000';
const primaryText = '#fff';
const borderColor = '#888';
const highlightBackgroundColor = '#fff';
const highlightForegroundColor = '#000';

export const baseStyles = {
    Workspace: {
        backgroundColor: '#666',
        color: primaryText,
    },

    Window: {
        backgroundColor: '#555',
        color: primaryText,
    },

    Accent: {
        backgroundColor: accentColor,
    },

    Bordered: {
        border: `solid 1px ${borderColor}`,
    },

    BorderedActive: {
        border: 'solid 1px #FF0',
    },

    Button: {
        backgroundColor: 'transparent',
        color: primaryText,
        border: `solid 1px ${accentColor}`,
    },
    Button_Focus_After: {
        position: 'absolute',
        top: '2px',
        left: '2px',
        right: '2px',
        bottom: '2px',
        width: '100%',
        height: '100%',
        display: 'inline-block',
        border: `dotted 1px ${primaryText}`,
    },

    DatePicker: {
        ActiveDay: {
            backgroundColor: highlightBackgroundColor,
            color: highlightForegroundColor,
        },
        DayNames: {
            borderBottom: `solid 1px ${primaryText}`,
        },
    },

    Error: {
        color: '#c00',
    },

    FillForeground: {
        fill: primaryText,
    },
    FillInvertForeground: {
        fill: highlightForegroundColor,
    },

    Highlighted: {
        backgroundColor: highlightBackgroundColor,
        color: highlightForegroundColor,
    },

    Input: {
        color: primaryText,
        border: `solid 1px ${borderColor}`,
        padding: '.2em .3em',
        outline: 'none',
    },

    Section: {
    },
    SectionHeader: {
    },

    Splitter: {
        backgroundColor: '#888',
    },

    Table: {
    },
    THead: {
    },
    TR: {
        cursor: 'pointer',
    },
    TR_Selected: {
        background: highlightBackgroundColor,
        color: highlightForegroundColor,
        transition: 'color .2s ease-out, background-color .2s ease-out',
        cursor: 'default',
    },
    TD: {
        transition: 'color .2s ease-out, background-color .2s ease-out',
    },

    Text: {
        color: primaryText,
    },

    Timeline: {
        backgroundColor: '#777',
    },

    Warning: {
        color: '#fff000',
    },
};


// WEBPACK FOOTER //
// ./src/ui/styles/baseStyles.ts